import React from 'react'
import { Link } from "react-router-dom"
import styled from "styled-components"
import media from "styled-media-query"

import hsBg from "../../image/hsbg.jpg"
import jhsBg from "../../image/jhsbg.jpg"
import esBg from "../../image/esbg.jpg"
import otherBg from "../../image/otherbg.jpg"

const FindCourses = ({setSchool}) => {

   return (
      <FindCoursesStyles
         hsBg={hsBg}
         jhsBg={jhsBg}
         esBg={esBg}
         otherBg={otherBg}
      >

         <div className="title-box">
            <h2>コースを探す</h2>
            <div className="deco"></div>
         </div>

         <div className="schools-box">
            <div className="school hs">
               <Link to="/courses" onClick={() => setSchool("hs")}>
                  <h3>高校生</h3>
               </Link>
            </div>
            <div className="school jhs">
               <Link to="/courses" onClick={() => setSchool("jhs")}>
                  <h3>中学生</h3>
               </Link>
            </div>
            <div className="school es">
               <Link to="/courses" onClick={() => setSchool("es")}>
                  <h3>小学生</h3>
               </Link>
            </div>
         </div>
      </FindCoursesStyles>
   )
}

const FindCoursesStyles = styled.section`
   width: 100%;
   .schools-box {
      display: flex;
      margin-top: 1px;
      .school {
         width: calc(100% / 3);
         height: 144px;
         background-size: cover;
         border-right: 1px solid #fff;
         ${media.lessThan("960px")`
            width: 50%;
            height: 140px;
         `}
         ${media.lessThan("600px")`
            height: 100px;
         `}
         h3 {
            width: 100%;
            height: 100%;
            background-color: #FF3D0180;
            color: #fff;
            font-size: 2.2rem;
            text-align: center;
            line-height: 144px;
            transition: 0.3s;
            &:hover {
               cursor: pointer;
               background-color: #FF3D0199;
            }
            ${media.lessThan("960px")`
               line-height: 140px;
            `}
            ${media.lessThan("600px")`
               line-height: 100px;
            `}
         }
      }
      .hs {
         background-image: url(${({hsBg}) => hsBg});
      }
      .jhs {
         background-image: url(${({jhsBg}) => jhsBg});
      }
      .es {
         background-image: url(${({esBg}) => esBg});
      }
   }
`

export default FindCourses